import { DTOBuilding, DTOModule } from "../types/building";
import { DBModuleType, ModuleStatuses, ModuleTypeId } from "../types/DBTables";

export interface IWizardViewModel {
  building: DTOBuilding;
}

let activeWizardBuilding: DTOBuilding | undefined = undefined;

export class WizardHandler {
  allModuleTypes = [] as DBModuleType[];

  public startWizard = (wizardBuilding: DTOBuilding, moduleTypes: DBModuleType[]) => {
    activeWizardBuilding = { ...wizardBuilding };
    activeWizardBuilding.modules = wizardBuilding.modules.map((m) => {
      return { ...m };
    });
    this.allModuleTypes = moduleTypes;
  };

  public addWizardModule = (moduleTypeId: ModuleTypeId) => {
    if (!activeWizardBuilding) return;

    let newMod: DTOModule;
    let newId = activeWizardBuilding.modules.reduce((min, m) => (m.id < min ? m.id : min), 1);
    newId = newId < 1 ? newId - 1 : -1;
    let defaultName = this.getNewModuleDefaultName(moduleTypeId);

    newMod = {
      id: newId,
      name: defaultName,
      moduleTypeId: moduleTypeId,
      status: ModuleStatuses.Created,
      data: "{}",
    };

    activeWizardBuilding.modules.push(newMod);
  };

  public removeModule = (mId: Number) => {
    if (!activeWizardBuilding) return;

    let mds = activeWizardBuilding.modules.filter((m) => m.id !== mId);
    activeWizardBuilding.modules = mds;
  };

  public updateModuleData = (module: DTOModule) => {
    if (!activeWizardBuilding) return;

    let m = activeWizardBuilding.modules.find((m) => m.id !== module.id);
    if (!m) return;

    m.name = module.name;
    m.data = module.data;
    m.status = module.status;
  };

  public getNewModuleDefaultName = (mtId: ModuleTypeId) => {
    let c: number;
    let cStr: string;
    let name: string;
    let mt = this.allModuleTypes.find((mt) => mt.id === mtId);
    if (!mt) return "";

    if (activeWizardBuilding) c = activeWizardBuilding?.modules.filter((mt) => mt.moduleTypeId === mtId).length + 1;
    else c = 1;

    if (c < 10) cStr = "0" + c;
    else cStr = "" + c;

    switch (mt.id) {
      case ModuleTypeId.VarmePrimarFjarr:
        name = "FJV" + cStr;
        break;
      case ModuleTypeId.VarmePrimarPump:
        name = "VP" + cStr;
        break;
      case ModuleTypeId.VarmePrimarLuftburen:
        name = "Luftburen värme";
        break;
      case ModuleTypeId.VarmeSekundarVatten:
        name = "VS" + cStr;
        break;
      case ModuleTypeId.VarmeElVarmepump:
        name = "Värmepump Luft / Luft";
        break;
      case ModuleTypeId.VarmeElStralningsvarmare:
        name = "Strålningsvärmare";
        break;
      case ModuleTypeId.VarmeElGolvvarme:
        name = "Elektrisk golvvärme";
        break;
      case ModuleTypeId.VarmeElAirotemper:
        name = "EL airotemper";
        break;
      case ModuleTypeId.VarmeElRadiatorer:
        name = "Elradiatorer";
        break;
      case ModuleTypeId.KylaVattenburet:
        name = "KB" + cStr;
        break;
      case ModuleTypeId.KylaMaskin:
        name = "KM" + cStr;
        break;
      case ModuleTypeId.VentilationFTX:
        name = "FTX" + cStr;
        break;
      case ModuleTypeId.VentilationFT:
        name = "FT" + cStr;
        break;
      case ModuleTypeId.VentilationFX:
        name = "FX" + cStr;
        break;
      case ModuleTypeId.VentilationF:
        name = "F" + cStr;
        break;
      case ModuleTypeId.VentilationS:
        name = "Självdrag" + cStr;
        break;
      case ModuleTypeId.KylaSaknas:
        name = "Kyla saknas";
        break;
      case ModuleTypeId.VarmePrimarSaknas:
        name = "Primärvärme saknas";
        break;
      case ModuleTypeId.VarmePrimarAnnatSystem:
        name = "Annat system";
        break;
      case ModuleTypeId.KylaAnnatSystem:
        name = "Annat system";
        break;
      case ModuleTypeId.VarmeSekundarSaknas:
        name = "Sekundärvärme saknas";
        break;
      default:
        name = "";
        break;
    }

    return name;
  };

  public getWizardBuilding(): DTOBuilding | undefined {
    return activeWizardBuilding;
  }

  getWizardBuildingDefaultData() {
    let b = this.getWizardBuilding();
    if (!b) return {};

    let data: any;
    data = {
      building: { namn: b.name },
    };

    b.modules.forEach((m) => {
      let moduleData = m?.data ? JSON.parse(m.data) : {};
      let d = { name: m.name, data: moduleData };
      data[m.id] = d;
    });

    return data;
  }
}

const theClass = new WizardHandler();

export const useWizardHandler = () => {
  return theClass;
};

const dflt = { useWizardHandler };

export default dflt;
